import Head from 'next/head';
import { ThemePage } from '@/components/themes/ThemePage';
import { ThemeInitiatives } from '@/components/themes/ThemeInitiatives';
import { ThemeEntities } from '@/components/themes/ThemeEmtities';

const SOCIAL_NETWORKING_SUB_CATEGORIES = [
  {
    title: 'Industry Mixers',
    description:
      'Casual networking events, after-work drinks, and industry socials where brands can sponsor and sample.',
  },
  {
    title: 'Professional Meetups',
    description:
      'Tech meetups, founder circles, and professional development events with brand partnership opportunities.',
  },
  {
    title: 'Community Gatherings',
    description:
      'Local community events, neighbourhood socials, and cultural gatherings that bring people together.',
  },
  {
    title: 'Co-working Spaces',
    description:
      'Brand activations, product sampling, and sponsorships in shared workspaces and innovation hubs.',
  },
  {
    title: 'Launch Parties & Openings',
    description:
      'Product launches, store openings, and celebration events where brands can reach engaged audiences.',
  },
  {
    title: 'Social Clubs & Groups',
    description:
      'Running clubs, book clubs, hobby groups, and interest-based communities looking for brand partners.',
  },
];

export default function SocialNetworkingThemePage() {
  return (
    <>
      <Head>
        <title>Social & Networking | Sizzle</title>
        <meta
          name="description"
          content="Networking events, social mixers, industry meetups, and brand activations that bring people together."
        />
      </Head>
      <ThemePage
        breadcrumbs={[{ label: 'Themes', href: '/themes' }, { label: 'Social & Networking' }]}
        title="Social & Networking"
        description="Connect brands with people at the moments they're most open to discovery — networking events, social mixers, meetups, and community gatherings. Reach engaged audiences in relaxed, social settings."
        heroImage=""
        subCategoriesTitle="Meet people where they connect"
        subCategoriesSubtitle="From industry mixers to community gatherings — find the right social moment to introduce your brand."
        subCategories={SOCIAL_NETWORKING_SUB_CATEGORIES}
      >
        <ThemeInitiatives
          title="Featured Initiatives"
          subtitle="Social and networking initiatives from brands and partners."
          categories={['trade']}
          limit={6}
          themes={['social-networking']}
        />

        <ThemeEntities
          title="Featured Brands and Businesses"
          subtitle="Brands and businesses active in social and networking spaces."
          roles={['brand', 'supplier']}
          limit={8}
          themes={['social-networking']}
        />
      </ThemePage>
    </>
  );
}
